import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../Components/Header/Header.js";
import LeftMenu from '../../../Components/LeftMenu/LeftMenu.js';
import TopMenu from '../../../Components/TopMenu/TopMenu.js';
// import TopMenu from '../common/TopMenu';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { ReactSearchAutocomplete } from 'react-search-autocomplete'

import ActiveTrips from './ActiveTrips';
import Planning from './Planning';
import ULDStock from './ULDStock';
import BuildUp from './BuildUp';

import Details from './FUldDetails.js';
import PTDetails from './PTDetails.js';
import AddULD from './Components/AddUldForwarder.js';

import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import { ULDSEARCH, ULDSEARCHDETAILS } from '../../../Utils/conts.js';
import PlanTrip from './Components/PlanTrip.js';
import Charts from '../../Charts/FULD/Charts.js';

const ULDForwarder = () => {

    // const queryParameters = new URLSearchParams(window.location.search);
    // const action = queryParameters.get("tab");
    // const initialTab = queryParameters.get("tab") || 'assets';
    const initialTab = localStorage.getItem("Maintab") || 'activetrips';
    const initPage = localStorage.getItem("InnerPage") || '';
    const isMounted = useRef(false);
    const [mainTab, setMainTab] = useState(initialTab);
    const [innerPage, setInnerPage] = useState(initPage);

    const [searchItems, setSearchItems] = useState([])
    const fetchDataGrid = async () => {
        try {
            const res = await withRFSToken.post(ULDSEARCH, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData.map((name, index) => ({
                        id: index,
                        name: name
                    }));
                    setSearchItems(transformedData);

                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const handleMainClick = (button) => {
        localStorage.removeItem('grid_tab');
        setMainTab(button);
        localStorage.setItem('Maintab', button);
    };
    useEffect(() => {
        if (isMounted.current) return;
        // Call the fetchData function to fetch data from the API
        // fetchDataGrid();
        isMounted.current = true;
    }, []);

    const handlenewLink = (page = '', main = null) => {
        console.log('page', page);

        setInnerPage(page);
        localStorage.setItem('InnerPage', page);

        if (main) {
            setMainTab(main);
            localStorage.setItem('Maintab', main);
        }
    };

    const handleOnSearch = (string, results) => {
        // onSearch will have as the first callback parameter
        // the string searched and for the second the results.
        console.log(string, results)
    }

    const handleOnHover = (result) => {
        // the item hovered
        console.log(result)
    }

    const handleOnSelect = async (item) => {
        // the item selected
        console.log(item)
        try {
            const res = await withRFSToken.post(ULDSEARCHDETAILS, { uld_number: item.name });
            if (res.data.response_code == 200) {
                localStorage.removeItem('MHistory');
                const storageData = {
                    ULD: res.data.response_data,  // ULD Details section
                    Form: {}  // Empty form section
                };
                localStorage.setItem('MHistory', JSON.stringify(storageData));
                localStorage.setItem('Ftab', initialTab);
                window.location.href = '/ULDControl/MovementHistory'
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handleOnFocus = () => {
        // console.log('Focused')
    }
    return (
        <>
            <div className="">
                <Header />
                <div className="page-body-wrapper schedule">
                    <LeftMenu module='UF' onTab={handlenewLink} selectedTab={innerPage} />
                    {innerPage === '' &&
                        <div className="main-panel rounded">
                            <div className="mainTab">
                                <TopMenu module='FORWARDER' onTab={handleMainClick} selectedTab={mainTab} />
                                <div className="">
                                    <div className="allcontent-fl">
                                        <div className='d-flex justify-content-between mb-3'>

                                            {/* <div className='search'>
                                            <div className="form-group has-search">
                                            
                                                <ReactSearchAutocomplete
                                                    items={searchItems}
                                                    onSearch={handleOnSearch}
                                                    onHover={handleOnHover}
                                                    onSelect={handleOnSelect}
                                                    onFocus={handleOnFocus}
                                                    autoFocus
                                                    placeholder="Search ULD"
                                                // formatResult={formatResult}
                                                />
                                            </div>
                                        </div> */}
                                        </div>
                                        <div className="lcontent">
                                            {mainTab === 'activetrips' &&
                                                <ActiveTrips
                                                    DClick={() => handlenewLink('D')}
                                                    PDClick={() => handlenewLink('PD')}
                                                    PtClick={() => handlenewLink('PT')}
                                                    stockClick={() => handlenewLink('', 'uldstock')}
                                                />
                                            }
                                            {mainTab === 'planning' &&
                                                <Planning
                                                    DClick={() => handlenewLink('D')}
                                                    AddClick={() => handlenewLink('AD')}
                                                />
                                            }
                                            {mainTab === 'uldstock' &&
                                                <ULDStock
                                                    DClick={() => handlenewLink('D')}
                                                    PDClick={() => handlenewLink('PD')}
                                                    AddClick={() => handlenewLink('AD')}
                                                    PtClick={() => handlenewLink('PT')}
                                                    tripsClick={() => handlenewLink('', 'activetrips')}
                                                />
                                            }
                                            {mainTab === 'buildup' && <BuildUp DClick={() => handlenewLink('D')} />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {innerPage === 'D' && <Details onBack={() => handlenewLink('')} PDClick={() => handlenewLink('PD')} AddClick={() => handlenewLink('AD')} />}
                    {innerPage === 'PD' && <PTDetails onBack={() => handlenewLink('')} onDBack={() => handlenewLink('D')} />}
                    {innerPage === 'AD' && <AddULD onBack={() => handlenewLink('')} />}
                    {innerPage === 'PT' && <PlanTrip onBack={() => handlenewLink('')} />}
                    {innerPage === 'CH' && <Charts onBack={() => handlenewLink('')} />}
                </div>
            </div>
        </>
    )
}

export default ULDForwarder;